export default {
  computed: {
    mixinsGroupByDateLogs() {
      const grouper = this.getterLogs.messages.reduce((group, currentValue) => {
        const groupBy = { ...group };
        const d = (currentValue.message.timestampLogs)
          ? new Date(currentValue.message.timestampLogs)
          : new Date(currentValue.message.timestamp);
        const date = this.mixinsDateFormatDate(d, true);
        groupBy[date] = groupBy[date] || [];
        groupBy[date].push(currentValue.message);
        return groupBy;
      }, {});
      return Object.keys(grouper).sort().reduce((group, current) => {
        const sort = { ...group };
        sort[current] = grouper[current];
        return sort;
      }, {});
    },
  },
};
